<template>
  <div v-show="show" class="mediaSort-container">
    <div class="mediaSort-content">
      <i @click="close" class="close"></i>
      <p class="title">看板顺序</p>
      <ul>
        <draggable
          class="dragArea list-group"
          :list="list"
          :group="{ name: 'comp', pull: 'clone', put: false }"
          @change="log"
        >
          <li v-for="(item, index) in list" :key="index">
            <div class="left">
              <i>{{item.first}}</i>
              <span>{{item.title}}</span>
            </div>
            <div class="right"></div>
          </li>
        </draggable>
      </ul>
      <div class="btns">
        <p @click="submit" class="btn">确定</p>
        <p @click="close" class="btn">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable
  },
  data() {
    return {
      show: false,
      list: [],
      callback: null
    }
  },
  methods: {
    open(config, callback) {
      config = JSON.parse(JSON.stringify(config))
      config.forEach(el => {
        el.first = el.title.substr(0,1)
      });
      this.list = config
      this.callback = callback
      this.show = true
    },
    submit() {
      let list = []
      this.list.forEach((el,index) => {
        list.push({
          id: el.id,
          sort: ++index
        })
      })
      this.callback(list)
      this.show = false
    },
    close() {
      this.callback(false)
      this.show = false
    },
    log() {

    }
  }
}
</script>

<style scoped lang="less">
  .mediaSort-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: rgba(50, 59, 75, 0.3); 
    backdrop-filter: blur(1.6px);

    .mediaSort-content {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 520px;
      height: 598px;
      background: #F9F9F9;
      border-radius: 4px;
      padding: 20px 30px 24px;
      box-sizing: border-box;

      .close {
        position: absolute;
        top: 20px;
        right: 20px;
        display: block;
        width: 20px;
        height: 20px;
        background: url('./assets/delIcon.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        user-select: none;
        cursor: pointer;
      }

      &>.title {
        font-size: 24px;
        line-height: 33px;
        color: #323B4B;
        font-weight: bold;
        margin-bottom: 20px;
      }

      ul {
        display: flex;
        flex-direction: column;
        width: 460px;
        height: 438px;
        background: rgba(185, 195, 195, 0.15);
        border-radius: 4px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(185,195,195,0.5);
          border-radius: 3px;
        }

        li {   
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          min-height: 50px;
          padding: 0 30px 0 16px;
          box-sizing: border-box;
          user-select: none;
          cursor: pointer;

          &:hover {
            background: rgba(185, 195, 195, 0.15);
            .right {
              display: block;
              width: 20px;
              height: 14px;
              background: url('./assets/edit.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }
          }

          .left {
            display: flex;
            flex-direction: row;
            align-items: center;

            i {
              display: block;
              width: 30px;
              height: 30px;
              background: #D5E3DE;
              border-radius: 50%;
              font-size: 16px;
              color: #41B48C;
              line-height: 30px;
              margin-right: 10px;
              text-align: center;
            }

            span {
              font-size: 13px;
              line-height: 18px;
              color: #323B4B;
              font-weight: 500;
            }
          }
        }
      }

      .btns {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 24px;

        .btn {
          width: 120px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 25px;
          border: 1px solid #41B48C;
          font-size: 14px;
          color: #41B48C;
          user-select: none;
          cursor: pointer;
          font-weight: 500;

          &:nth-last-of-type(1) {
            margin-left: 20px;
            color: #FFF;
            background: #41B48C;
          }
        }
      }
    }
  }
</style>